import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data1 from "../../Data/publicationsData1.json";
import data2 from "../../Data/publicationsData2.json";

export default function Publications() {
  useSEO(seoConfig.publications);

  return (
    <section className="licenses antiCorruption publications">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title development__title">
        Научные публикации
      </h1>

      <div>
        <Accordion data={data1} />
        <h3 className="about-nii__title antiCorruption__title">
          Методические рекомендации
        </h3>
        <Accordion data={data2} />
      </div>
    </section>
  );
}
